export default "__VITE_ASSET__Zq3y9n8h__"